import instance from '@/api/api'

//用户登录
export const pcUserLogin  = params =>{
  return instance.post('/code/userLogin', params);
}

//用户登出
export const pcUserLoginOut  = params =>{
  return instance.post('/code/userLoginOut', params);
}
//更新密码
export const updateUserPassword  = params =>{
  return instance.post('/user/updateUserPassword', params);
}

//获取注册验证码
export const getIdenCode  = params =>{
  return instance.get('/code/send/' + params);
}
//获取绑定手机验证码
export const getBindCode = params =>{
  return instance.post('/user/getPhoneCode?'+params);
}

//普通用户注册
export const customerRegister = params =>{
  return instance.post('/code/userRegist', params);
}
//律师用户注册(即提供商)
export const supplierRegist = params =>{
  return instance.post('/code/supplierRegist', params);
}
//用户登出
export const loginOut = params =>{
  return instance.post('/code/userLoginOut',params);
}
//手机验证找回密码
export const phoneGetBackPwd = params =>{
  return instance.post('/code/resetPasswordByPhone', params);
}
//获取登录二维码
export const getLoginQrcode = () =>{
  return instance.post('/common/getLoginQrcode');
}
//论循登录
export const loginByQrcode = params =>{
  return instance.post('/common/loginByQrcode', params);
}





// WEBPACK FOOTER //
// ./src/api/userInfo/userLogin.js